// ============================================================
// THE MAP'S SPECIALS, IN THE PLATE'S SHAPES (plan design-gaps, K6).
//
// The plate draws each weapon special as its own look (components/plate/fx/
// specials: Melta's white-hot point, Shock's crawling arcs, Flame's tongues,
// a holy shaft, psychic rings, a blade's glint, Concussive's push...). The
// map plays the same specials at a figure's scale, so it takes the same
// FAMILY of shape for each, drawn with a few strokes rather than the plate's
// line art and clips: the key names its shape, and a special the table does
// not name falls back on its role's.
//
// Pure. Zero React dependency.
// ============================================================
import type { SpecialRole } from '../plate/specials';

/** The shape a special takes on the map. */
export type AccentShape =
  'point' | 'flames' | 'arcs' | 'drips' | 'tear' | 'triplet' | 'shaft' | 'rings' | 'glint' | 'push' | 'pull' | 'mark';

/** Each special's shape, by its look's key (engine/plate/specials), as the plate draws it. */
const BY_KEY: Readonly<Record<string, AccentShape>> = {
  melta: 'point',
  flame: 'flames',
  volatile: 'flames',
  shock: 'arcs',
  haywire: 'arcs',
  corrosive: 'drips',
  toxicw: 'drips',
  // The plate's hammer triplet (engine/plate/triplet, ruled 2026-10-23); Felling keeps the ragged cut.
  tearing: 'triplet',
  felling: 'tear',
  sanctified: 'shaft',
  blessed: 'shaft',
  exorcist: 'shaft',
  force: 'rings',
  warp: 'rings',
  witchbane: 'rings',
  impetus: 'push',
  concussive: 'push',
  graviton: 'pull',
};

/** A role's shape, for a special the table does not name. */
const BY_ROLE: Readonly<Record<SpecialRole, AccentShape>> = {
  blade: 'glint',
  motion: 'push',
  element: 'flames',
  accent: 'shaft',
  after: 'mark',
};

/** The shape a special takes on the map: its own, else its role's. */
export const accentShapeOf = (key: string, role: SpecialRole): AccentShape => BY_KEY[key] ?? BY_ROLE[role];
